/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function showToast(options, context) {
    var _a;
    var api = 'dd.device.notification.toast';
    var formatInput = function (input) {
        var duration = input.duration, content = input.content;
        var getDuration = function () {
            if (duration) {
                return duration > 100 ? duration / 1000 : duration;
            }
            return 2;
        };
        return {
            icon: '',
            text: content,
            duration: getDuration(),
            delay: 0,
        };
    };
    (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatInput: formatInput });
}

export { showToast as default };
